<div class="modal-content-wrapper" *ngIf="active">
    <div class="modal-header">
        <h4 class="modal-title">
            <span>{{ entityObjectDisplayName | localize }} </span>
            <p class="desc-menu-item">
                {{ l("SelectFromTheBelow") }} {{ " " }}
                {{ entityObjectDisplayName | localize }}
            </p>
        </h4>

        <button
            style="position: absolute; right: 0; top: 8px"
            type="button"
            class="close"
            (click)="close()"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0 mr-2">
        <p class="title-tree ml-3">
            {{ entityObjectDisplayName | localize }}
        </p>
        <div
            class="align-items-center border d-flex m-3 pb-2 pl-3 pt-2 rounded"
        >
            <span class="mr-3">
                <i class="fas fa-search"></i>
            </span>
            <input
                type="text"
                name="search"
                id="search"
                placeholder="Search"
                (input)="onFilter()"
                [(ngModel)]="searchQuery"
                class="form-control bg-white border-0"
            />
        </div>
        <p-tree
            styleClass="p-tree-with-actions"
            [value]="displayedRecords"
            selectionMode="checkbox"
            [filter]="false"
            [(selection)]="selectedRecords"
            [loading]="loading"
            (onNodeExpand)="loadClassificationsNode($event)"
        >
            <ng-template let-node pTemplate="default">
                <div
                    class="d-flex flex-wrap justify-content-between align-items-center"
                >
                    <div class="treenode-label-text">{{ node.label }}</div>
                    <div
                        class="treenode-action"
                        (click)="stopPropagation($event)"
                        *ngIf="showActions"
                    >
                        <div
                            class="btn-group dropdown"
                            dropdown
                            container="body"
                            placement="bottom right"
                        >
                            <button
                                title="actions"
                                class="dropdown-toggle btn btn-sm btn-action"
                                aria-controls="dropdown-alignment"
                                dropdownToggle
                            ></button>
                            <ul
                                id="dropdown-alignment"
                                class="dropdown-menu dropdown-action-btn dropdown-menu-right"
                                *dropdownMenu
                            >
                                <li>
                                    <a (click)="addAsNewChild(node)">{{
                                        "AddSubClassification" | localize
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        (click)="editClassifications(node)"
                                        >{{ "Edit" | localize }}</a
                                    >
                                </li>
                                <li>
                                    <a (click)="deleteSycEntityObject(node)">{{
                                        "Delete" | localize
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-tree>
        <div>
            <button
                class="btn btn-font-hover-brand ml-3"
                (click)="showMoreListData()"
                *ngIf="showMoreListDataButton"
            >
                {{ "showmore" | localize }} ...
            </button>
        </div>
    </div>
    <div class="modal-footer d-fex align-items-center justify-content-between">
        <button
            *ngIf="showAddAction"
            [title]="'AddNewClassification' | localize"
            type="button"
            class="btn btn-icon btn-primary btn-circle create-edit-btn"
            (click)="openCreateOrEditModal()" style="background-color: #4A0D4A !important;
            border: #4A0D4A !important;color: white;"
        >
            <i class="flaticon2-plus"></i>
        </button>
        <div>
            <button
                type="button"
                class="btn btn-default btn-gray"
                (click)="close()"
                style="border-radius: 5px;
                background-color: white !important;
                border: white !important;color: #4A0D4A !important;" >
                {{ l("Cancel") }}
            </button>
            <button
                type="submit"
                [disabled]="!selectedRecords?.length"
                (click)="submitSelection()"
                class="btn btn-primary blue btn-blue"
                style="border-radius: 5px;
                background-color: #4A0D4A !important;
                border: #4A0D4A !important;color: white;" >
                <span>{{ l("Add") }}</span>
            </button>
        </div>
    </div>
</div>
